import { useConfigContext } from "./useConfigContext";

export const useRequest = () => {

    const {setHasNetworkError} = useConfigContext();


    const requestWrapper = async (request: any) => {
        const response = await request();
        if (!response.successful && response.errors[0].code === 'client_network_error') {
            setHasNetworkError(true);
        }else{
            setHasNetworkError(false);
        }
        return response;
    }

    return {requestWrapper}
}
